import React from 'react'
import Bg from './money-fiesta-may-tg/images/links/background.jpg';
import { Grid, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';

function CampaignError() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const ck_id = params.get('ck_id');
    return (
        <Grid container>
            <Grid item xs={12} sm={12} md={4} lg={4}></Grid>
            <Grid item xs={12} sm={12} md={4} lg={4}
                sx={{
                    backgroundImage: `url(${Bg})`,
                    backgroundSize: 'cover',
                    height: "100vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
            <Typography  sx={{ color: "white",fontSize:'1rem', fontWeight:'600', textAlign:'center' }}px={2.5}>You’re not eligible for this offer right now. 
            Stay tuned for more exciting offers coming your way!</Typography>

                {/* <Typography variant='h5' sx={{ color: "white" }}>UserID not found : {ck_id}</Typography> */}
                {/* <Typography variant='h5' sx={{ color: "white" }}>{ck_id}</Typography> */}
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4}></Grid>
        </Grid>

    )
}

export default CampaignError